var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSquareHalfBottom = function SvgIconSquareHalfBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.875 20.875a1.75 1.75 0 0 1-1.75-1.75V4.875c0-.966.784-1.75 1.75-1.75h14.25c.966 0 1.75.784 1.75 1.75v14.25a1.75 1.75 0 0 1-1.75 1.75zm.25-15.75V11h13.75V5.125zm10 7.875H13v5.875h2.125zm2 5.875V13h1.75v5.875zM8.875 13H11v5.875H8.875zm-2 0h-1.75v5.875h1.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSquareHalfBottom;